export default {
  TNC_ERROR: "Per accedere, devi prima accettare i Termini e condizioni di Fielddrive e l'Informativa sulla privacy.",
  WELCOME_BACK: 'Bentornato! Hai effettuato il log in con successo.',
  TNC_LABEL: 'selezionando questa casella accetti i Fielddrive Leads',
  TNC: 'Condizioni del servizio',
  TNC_LINK: 'https://www.fielddrive.com/terms-and-conditions',
  LOWER_AND: 'e',
  POLICY: 'Informativa sulla privacy',
  POLICY_LINK: 'https://www.fielddrive.com/privacy-policy',
  POLICY_LABEL: 'Autorizzi Fielddrive derivazioni a trattare i tuoi dati personali per le finalità ivi specificate.',
  LOGIN: 'Accesso'
}
